import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type OfficerState = CommonTableState;

const initialState: OfficerState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "licence.company.id", desc: false }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnOrder: ["licence.company.id", "user.person.id", "user.id", "creator", "created", "mrt-row-actions"],
        columnVisibility: {
        },
        density: "compact",
    },
};

export const officerSlice = createSlice({
    name: "officer",
    initialState: initialState,
    reducers: {
        updateOfficerTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const { updateOfficerTableState } = officerSlice.actions;

export default officerSlice.reducer;
